import styled from '@emotion/styled';
import { RebrandTheme } from '../../../../common/models/common.models';
import { css } from '@emotion/react';
import { StyledSkeleton } from '../../Header.style';

export const Backdrop = styled.div<{ isontop: boolean }>`
    position: fixed;
    width: 100%;
    height: calc(100vh - ${({ isontop }) => (isontop ? '78px' : '46px')});
    z-index: 100;
    left: 0;
    top: ${props => (props.isontop ? '78px' : '46px')};
    background-color: rgba(45, 47, 60, 0.4);
`;

export const ModalWrapper = styled.div<{ isontop: boolean }>`
    position: fixed;
    z-index: 500;
    background-color: white;
    top: ${props => (props.isontop ? '79px' : '47px')};
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 0.88px 5.27px 0 #00000026;
    @media (max-width: 1260px) {
        width: 100vw;
    }
`;

export const CreateMenuWrapper = styled.div<{ showModal?: boolean }>`
    display: flex;
    flex-direction: column;
    margin: 0 10%;
    opacity: ${props => (props.showModal ? '1' : '0')};
    transition: all 0.4s ease-in;
    @media (min-width: 1200px) {
        max-width: 1152px;
        margin: 0 auto;
    }
`;

//NEW DESIGN

export const InnerModalWrapper = styled.div`
    display: flex;
`;

export const SolutionsWrapper = styled.div`
    padding: 40px 28px 40px 40px;
    flex-grow: 1;
`;

export const ActionsWrapper = styled.div`
    border-left: 1px solid #c5c8c9;
    padding: 40px 40px 40px 28px;
`;

export const InnerActionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ActionArrowWrapper = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff039117;
    border-radius: 50%;
    path {
        fill: #ff0391;
    }
`;

export const ActionButton = styled.button<{ theme?: RebrandTheme }>`
    ${({ theme }) =>
        css`
            ${theme.header.createMenu.actions}
        `}
    width: 100%;
    height: 40px;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 20px;
    transition: all 0.3s ease;
    white-space: nowrap;
`;

export const CreateButton = styled(ActionButton)`
    color: #ffffff;
    background: linear-gradient(
        108.92deg,
        rgba(0, 17, 176, 0.6) -141.58%,
        rgba(255, 3, 145, 0.6) -30.82%,
        rgba(0, 127, 230, 0.6) 101.05%
    );
    border: 1px solid #eeeff799;

    &:hover {
        background: linear-gradient(
                108.92deg,
                rgba(0, 17, 176, 0.4) -141.58%,
                rgba(255, 3, 145, 0.4) -30.82%,
                rgba(0, 127, 230, 0.4) 101.05%
            ),
            linear-gradient(0deg, rgba(0, 127, 230, 0.03), rgba(0, 127, 230, 0.03));
    }

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        transition: none;
    }
`;

export const ExploreButton = styled(ActionButton)`
    background: #ffffff;
    color: #5f4594cc;
    border: 1px solid #5f4594cc;
    padding: 0 24px;

    &:hover {
        color: #5f4594cc;
        background: #5f45941a;
    }

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        transition: none;
    }
`;

export const InnerSolutionsWrapper = styled.div`
    display: flex;
    gap: 40px;
`;

export const SolutionColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const CategoryRow = styled.div<{ theme?: RebrandTheme }>`
    ${({ theme }) =>
        css`
            ${theme.header.createMenu.categoryRow}
        `};
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 16px;
    text-transform: UpperCase;
`;

export const SolutionArrowWrapper = styled(ActionArrowWrapper)`
    background: #0011af17;
    opacity: 0;
    transition: opacity 0.3s ease;
    min-width: 24px;
    path {
        fill: #0011b0;
    }
`;

export const SolutionButton = styled.button<{ theme?: RebrandTheme }>`
    cursor: pointer;
    border-radius: 8px;
    min-height: 88px;
    width: 292px;
    border: none;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    gap: 8px;
    align-items: center;
    background-color: #ffffff;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #f5f5fe;
        ${SolutionArrowWrapper} {
            opacity: 1;
        }
    }

    &:focus-visible {
        outline: 4px solid ${props => props.theme.header.outlineColor};
        outline-offset: 0;
        border-radius: 8px;
        transition: none;
    }
`;

export const SolutionText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
`;

export const SolutionName = styled.div<{ theme?: RebrandTheme }>`
    ${({ theme }) =>
        css`
            ${theme.header.createMenu.solutionName}
        `};
    display: flex;
    align-items: center;
    gap: 8px;

    div {
        background-color: #ff0391 !important;
        span {
            color: #ffffff !important;
        }
    }
`;

export const SolutionShortDescription = styled.div<{ theme?: RebrandTheme }>`
    ${({ theme }) =>
        css`
            ${theme.header.createMenu.solutionShortDescription}
        `};
`;

export const CreateButtonStylesSkeleton = styled(StyledSkeleton)`
    &.MuiSkeleton-root {
        border-radius: 20px;
    }
`;

export const SolutionButtonSkeleton = styled(SolutionButton)`
    pointer-events: none;
`;
